/**
 * ControlConstants.ts
 */
export class ControlConstants {
}
ControlConstants.LOCALISE = "localise";
ControlConstants.GAME_DEV = "gameDev";
ControlConstants.LEFT = "left";
ControlConstants.CENTER = "center";
ControlConstants.RIGHT = "right";
ControlConstants.TOP = "top";
ControlConstants.BOTTOM = "bottom;"; // typo
/*
 * ScrollConstants.ts
 */
export class ScrollConstants {
}
ScrollConstants.VERTICAL = "V";
ScrollConstants.HORIZONTAL = "H";
ScrollConstants.AS_REQUIRED = 0;
ScrollConstants.ALWAYS = 1;
/*
 * SpineConstants.ts
 */
export class SpineConstants {
}
SpineConstants.ANIMATION = "animation";
SpineConstants.MULTIPLE = "multiple";
SpineConstants.SINGLE = "single";
/*
 * ButtonConstants.ts
 */
export class ButtonConstants {
}
ButtonConstants.DEFAULT = 0;
ButtonConstants.ROLLOVER = 1;
ButtonConstants.PRESSED = 2;
ButtonConstants.DISABLED = 3;
ButtonConstants.SELECTED_DEFAULT = 4;
ButtonConstants.SELECTED_ROLLOVER = 5;
ButtonConstants.SELECTED_PRESSED = 6;
ButtonConstants.SELECTED_DISABLED = 7;
/*
 * ButtonConstantsNamed.ts
 */
export class ButtonConstantsNamed {
}
ButtonConstantsNamed.DEFAULT = "Up";
ButtonConstantsNamed.ROLLOVER = "Over";
ButtonConstantsNamed.PRESSED = "Down";
ButtonConstantsNamed.DISABLED = "Disabled";
ButtonConstantsNamed.SELECTED_DEFAULT = "SelectedUp";
ButtonConstantsNamed.SELECTED_ROLLOVER = "SelectedOver";
ButtonConstantsNamed.SELECTED_PRESSED = "SelectedDown";
ButtonConstantsNamed.SELECTED_DISABLED = "SelectedDisabled";
//# sourceMappingURL=ControlConstants.js.map